import { render, staticRenderFns } from "./KeplrInfoModal.vue?vue&type=template&id=1521bf09&scoped=true&"
import script from "./KeplrInfoModal.vue?vue&type=script&lang=js&"
export * from "./KeplrInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./KeplrInfoModal.vue?vue&type=style&index=0&id=1521bf09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1521bf09",
  null
  
)

export default component.exports